import { createCommand } from '../../utils';
import { catalogsInitialized, moduleName } from '../state';

export const InitCatalogsCommand = createCommand(`${moduleName}/INIT_CATALOGS`, async (_, { dispatch, extra }) => {
    const { catalogs } = await extra.externalCatalogs.loadCatalogs();

    dispatch(catalogsInitialized({ catalogs }));
});
